import { ChangeDetectionStrategy, ChangeDetectorRef, Component, DestroyRef, Input, OnChanges, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { EventOptionGroup } from '@frontend/sports/betting-offer/feature/model';
import { MarketHelpConfig, Sitecore } from '@frontend/sports/common/client-config-data-access';
import { IconCustomComponent } from '@frontend/vanilla/shared/icons';

import { EpcotNotificationComponent } from '../../common/epcotNotifications/notification.component';
import { MarketHelpTrackingService } from './market-help-tracking.service';
import { MarketHelpService } from './market-help.service';
import { IMarketHelpResponse } from './model';

export enum MarketHelpTextDisplayVersion {
    V1 = 'V1',
    V2 = 'V2',
}
@Component({
    selector: 'ms-market-help',
    templateUrl: './market-help.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [EpcotNotificationComponent, IconCustomComponent],
})
export class MarketHelpComponent implements OnChanges {
    @Input() optionGroup: EventOptionGroup;
    @Input() eventHelpText?: string;

    vm: IMarketHelpResponse;
    private fallbackItem: string;
    noContentMessage: string;
    private readonly destroyRef = inject(DestroyRef);
    markethelpTextDisplayVersion = MarketHelpTextDisplayVersion;
    constructor(
        private marketHelpService: MarketHelpService,
        private changeDetectionRef: ChangeDetectorRef,
        private trackingService: MarketHelpTrackingService,
        public marketHelpConfig: MarketHelpConfig,
        private sitecore: Sitecore,
    ) {
        this.noContentMessage = this.sitecore.marketHelp.defaultMessage.NoContent;
        this.fallbackItem = marketHelpConfig.sitecoreFallbackItem;
    }

    ngOnChanges(): void {
        if (this.shouldLoadHelpText) {
            this.setEventHelp();

            return;
        }

        const marketHelpItem = this.optionGroup.detailedGrouping.marketHelpPath;
        this.loadHelp(marketHelpItem || this.fallbackItem);
    }

    track(): void {
        this.trackingService.trackLink(this.optionGroup, this.vm.href);
    }

    private loadHelp(marketHelpPath: string): void {
        this.marketHelpService
            .getHelp(marketHelpPath)
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((model) => {
                this.vm = model;
                this.changeDetectionRef.markForCheck();
            });
    }

    private get shouldLoadHelpText(): boolean {
        return !!this.eventHelpText;
    }

    private setEventHelp(): void {
        this.vm = { text: this.eventHelpText || '', href: '', link: '', target: '' };
    }
}
